import { gql } from "@apollo/client";

export const ACCESS_SCANS_REPORT = gql`
  query reports_access(
    $where: reports_access_bool_exp!
    $offset: Int!
    $limit: Int!
  ) {
    reports_access(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { scan_created_at: desc }
    ) {
      access_token_quantity
    access_token_type
    access_transaction_id
    event_id
    event_name
    id
    location_id
    location_name
    organization_id
    organization_name
    scan_created_at
    scan_status
    scan_status_message
    adjusted_scan_time
    uid
    user_id
    username
    }
  }
`;
export const ACCESS_SCANS_REPORT_COUNT = gql`
  query reports_access(
    $where: reports_access_bool_exp!
  ) {
    total: reports_access_aggregate(where: $where) {
      aggregate {
        count
        __typename
      }
      __typename
    }
  }
`;

// Optimized query that fetches only the minimal fields needed for ALL grouping types
// This allows fetching data once and switching between groupings instantly without refetching
export const ACCESS_SCANS_REPORT_OPTIMIZED = gql`
  query reports_access_optimized(
    $where: reports_access_bool_exp!
    $offset: Int!
    $limit: Int!
  ) {
    reports_access(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { scan_created_at: desc }
    ) {
      id
      event_id
      location_name
      access_token_type
      adjusted_scan_time
      scan_status
      uid
    }
  }
`;

export const ACCESS_SCANS_DASHBOARD_STATS = gql`
  query access_scans_dashboard_stats(
    $where: reports_access_bool_exp!
    $successWhere: reports_access_bool_exp!
    $failWhere: reports_access_bool_exp!
    $ingressWhere: reports_access_bool_exp!
    $egressWhere: reports_access_bool_exp!
  ) {
    total: reports_access_aggregate(where: $where) {
      aggregate {
        count
      }
    }
    success: reports_access_aggregate(where: $successWhere) {
      aggregate {
        count
      }
    }
    failed: reports_access_aggregate(where: $failWhere) {
      aggregate {
        count
      }
    }
    ingress: reports_access_aggregate(where: $ingressWhere) {
      aggregate {
        count
      }
    }
    egress: reports_access_aggregate(where: $egressWhere) {
      aggregate {
        count
      }
    }
  }
`;

export const ACCESS_SCANS_LOCATION_STATS = gql`
  query access_scans_location_stats(
    $where: reports_access_bool_exp!
  ) {
    reports_access(
      where: $where
    ) {
      location_name
    }
  }
`;

export const ACCESS_SCANS_HOURLY_STATS = gql`
  query access_scans_hourly_stats(
    $where: reports_access_bool_exp!
  ) {
    reports_access(
      where: $where
    ) {
      adjusted_scan_time
      access_token_type
    }
  }
`;
